module.exports = __webpack_public_path__ + "img/apply-poster.fb208280.jpg";